import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './PublicRoutes';
import AuthData from 'types/models/AuthData';
import AppContext from 'contexts/AppContext';
import AppHeader from 'components/AppHeader';
import LoadingSpinner from 'components/LoadingSpinner';

export default (): JSX.Element => {
  const [authData, setAuthData] = React.useState<AuthData | null>(null);
  const [permissions, setPermissions] = React.useState<string[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [currentPageListNumber, setCurrentPageListNumber] = React.useState<number | null | undefined>(1);

  if (!authData) {
    const storageAuthData = localStorage.getItem('auth-data');
    if (storageAuthData) {
      setAuthData(JSON.parse(storageAuthData));
    }
  }

  return (
    <BrowserRouter>
      <LoadingSpinner isLoading={isLoading} />
      <AppContext.Provider
        value={{
          authData,
          setAuthData,
          currentPageListNumber,
          setCurrentPageListNumber,
          isLoading,
          setIsLoading,
          permissions,
          setPermissions,
        }}
      >
        <AppHeader />
        <div className="app-container">
          <Switch>
            {/* Private Routes */}
            <Route path="/private" component={PrivateRoutes} />
            {/* Public Routes */}
            <Route path="/public" component={PublicRoutes} />
            <Redirect to={`${authData ? '/private/welcome' : '/public/login'}`} />
          </Switch>
        </div>
      </AppContext.Provider>
    </BrowserRouter>
  );
};
